<template>
  <div class="search-form">
    <el-input id="search_text" v-model="searchKey" :placeholder="$t('ent_srh_item')" />
    <el-button id="search_button" @click="search">{{ $t("go_mark") }}</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchKey: "",
    };
  },
  methods: {
    search() {
      const winoptions = "width=960,height=800";
      let url = "";
      if (this.searchKey === "" || this.searchKey === this.$t("ent_srh_item")) {
        url = "http://support.netgear.com/product/" + this.$store.state.page.host_name;
      } else {
        url = "http://kb.netgear.com/app/answers/list/kw/" + encodeURIComponent(this.searchKey);
      }
      window.open(url, "_blank", winoptions);
    },
  },
};
</script>
<style lang="scss">
.search-form {
  width: 100%;
  height: 100%;
  display: -webkit-flex; /* Safari */
  display: flex;
}
</style>
